<template>
<div class="about-info-navbar">
    <div class="external-space">
      <nav class="navbar">
    <div class="logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="150.322"
        height="44"
        viewBox="0 0 150.322 44"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectángulo_119"
              data-name="Rectángulo 119"
              width="150.322"
              height="44"
              fill="#fff"
            ></rect>
          </clipPath>
        </defs>
        <g id="Grupo_69" data-name="Grupo 69" transform="translate(0 0)">
          <rect
            class="fill__secundary"
            id="Rectángulo_113"
            data-name="Rectángulo 113"
            width="8.751"
            height="3.409"
            transform="translate(40.156 9.741)"
            fill="#fff"
          ></rect>
          <rect
            class="fill__secundary"
            id="Rectángulo_114"
            data-name="Rectángulo 114"
            width="15.307"
            height="3.409"
            transform="translate(33.6 17.454)"
            fill="#fff"
          ></rect>
          <rect
            class="fill__primary"
            id="Rectángulo_115"
            data-name="Rectángulo 115"
            width="30.614"
            height="3.409"
            transform="translate(18.293 25.166)"
            fill="#fff"
          ></rect>
          <rect
            class="fill__primary"
            id="Rectángulo_116"
            data-name="Rectángulo 116"
            width="36.799"
            height="3.409"
            transform="translate(12.109 32.879)"
            fill="#fff"
          ></rect>
          <rect
            class="fill__extra"
            id="Rectángulo_117"
            data-name="Rectángulo 117"
            width="48.907"
            height="3.409"
            transform="translate(0 40.591)"
            fill="#fff"
          ></rect>
          <path
            class="fill__secundary"
            id="Trazado_86"
            data-name="Trazado 86"
            d="M107.368.329V12.753h3.168V7.908h3.831V5.175h-3.831V3.084h4.535V.329Z"
            transform="translate(-51.416 -0.158)"
            fill="#fff"
          ></path>
          <g
            class="fill__secundary"
            id="Grupo_68"
            data-name="Grupo 68"
            transform="translate(0 0)"
          >
            <g
              class="fill__secundary"
              id="Grupo_67"
              data-name="Grupo 67"
              clip-path="url(#clip-path)"
            >
              <path
                class="fill__secundary"
                id="Trazado_87"
                data-name="Trazado 87"
                d="M135.542,12.742H131.98l-2.9-4.555h-.725v4.555h-3.168V.318h5.528a3.8,3.8,0,0,1,3.81,3.914A3.7,3.7,0,0,1,132.1,7.814Zm-4.059-8.386A1.24,1.24,0,0,0,130.2,3.072h-1.843V5.639H130.2a1.24,1.24,0,0,0,1.284-1.284"
                transform="translate(-59.95 -0.152)"
                fill="#fff"
              ></path>
              <path
                class="fill__secundary"
                id="Trazado_88"
                data-name="Trazado 88"
                d="M146.05,6.378a6.378,6.378,0,1,1,6.378,6.378,6.368,6.368,0,0,1-6.378-6.378m9.65,0a3.282,3.282,0,0,0-6.564,0,3.282,3.282,0,0,0,6.564,0"
                transform="translate(-69.94 0)"
                fill="#fff"
              ></path>
              <path
                class="fill__secundary"
                id="Trazado_89"
                data-name="Trazado 89"
                d="M186.117.318V12.741h-3.333l-5.591-7.62v7.62h-3.168V.318h3.313l5.611,7.6V.318Z"
                transform="translate(-83.337 -0.152)"
                fill="#fff"
              ></path>
              <path
                class="fill__secundary"
                id="Trazado_90"
                data-name="Trazado 90"
                d="M208.294,3.071H205.25v9.67H202.1V3.071h-3.044V.317h9.235Z"
                transform="translate(-95.325 -0.152)"
                fill="#fff"
              ></path>
              <path
                class="fill__secundary"
                id="Trazado_91"
                data-name="Trazado 91"
                d="M221.975,3.071V5.163h3.831V7.9h-3.831V9.987h4.535v2.754h-7.7V.317h7.7V3.071Z"
                transform="translate(-104.782 -0.152)"
                fill="#fff"
              ></path>
              <path
                class="fill__secundary"
                id="Trazado_92"
                data-name="Trazado 92"
                d="M247.479,12.742h-3.562l-2.9-4.555h-.725v4.555h-3.168V.318h5.528a3.8,3.8,0,0,1,3.81,3.914,3.7,3.7,0,0,1-2.423,3.582Zm-4.059-8.386a1.24,1.24,0,0,0-1.284-1.284h-1.843V5.639h1.843a1.24,1.24,0,0,0,1.284-1.284"
                transform="translate(-113.554 -0.152)"
                fill="#fff"
              ></path>
              <path
                class="fill__secundary"
                id="Trazado_93"
                data-name="Trazado 93"
                d="M264.369,10.567h-4.348l-.684,2.174h-3.416L260.414.318h3.541l4.494,12.424h-3.4ZM263.582,8,262.195,3.61,260.828,8Z"
                transform="translate(-122.555 -0.152)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_94"
                data-name="Trazado 94"
                d="M107.061,40.772a4.919,4.919,0,0,1,9.2-2.427l-.878.495a3.9,3.9,0,1,0,0,3.865l.878.495a4.919,4.919,0,0,1-9.2-2.427"
                transform="translate(-51.269 -17.169)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_95"
                data-name="Trazado 95"
                d="M127.227,40.772a4.918,4.918,0,1,1,4.918,4.918,4.92,4.92,0,0,1-4.918-4.918m8.814,0a3.9,3.9,0,1,0-3.9,3.9,3.871,3.871,0,0,0,3.9-3.9"
                transform="translate(-60.926 -17.169)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_96"
                data-name="Trazado 96"
                d="M155.975,38.765a2.638,2.638,0,0,1-2.667,2.651H150.9v4.263h-1.022V36.1h3.433a2.661,2.661,0,0,1,2.667,2.666m-1.022.016a1.666,1.666,0,0,0-1.741-1.693H150.9v3.353h2.315a1.622,1.622,0,0,0,1.741-1.661"
                transform="translate(-71.772 -17.287)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_97"
                data-name="Trazado 97"
                d="M170.441,38.765a2.638,2.638,0,0,1-2.667,2.651h-2.411v4.263h-1.022V36.1h3.433a2.661,2.661,0,0,1,2.667,2.666m-1.022.016a1.666,1.666,0,0,0-1.741-1.693h-2.315v3.353h2.315a1.622,1.622,0,0,0,1.741-1.661"
                transform="translate(-78.699 -17.287)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_98"
                data-name="Trazado 98"
                d="M179.981,37.089v3.3h3.672v.99h-3.672v3.3H184.2v.99h-5.237V36.1H184.2v.99Z"
                transform="translate(-85.699 -17.287)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_99"
                data-name="Trazado 99"
                d="M199.792,45.679h-1.166l-2.714-4.327h-1.8v4.327h-1.022V36.1h3.433a2.664,2.664,0,0,1,2.667,2.682,2.549,2.549,0,0,1-2.219,2.523Zm-3.337-5.3a1.607,1.607,0,0,0,1.708-1.629,1.625,1.625,0,0,0-1.708-1.629h-2.348v3.257Z"
                transform="translate(-92.464 -17.287)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_100"
                data-name="Trazado 100"
                d="M107.061,70.241a4.919,4.919,0,0,1,9.2-2.427l-.878.495a3.9,3.9,0,1,0,0,3.865l.878.495a4.919,4.919,0,0,1-9.2-2.427"
                transform="translate(-51.269 -31.281)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_101"
                data-name="Trazado 101"
                d="M127.227,70.241a4.918,4.918,0,1,1,4.918,4.918,4.92,4.92,0,0,1-4.918-4.918m8.814,0a3.9,3.9,0,1,0-3.9,3.9,3.871,3.871,0,0,0,3.9-3.9"
                transform="translate(-60.926 -31.281)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_102"
                data-name="Trazado 102"
                d="M156.58,75.149h-1.165L152.7,70.822h-1.8v4.327h-1.022v-9.58h3.433a2.665,2.665,0,0,1,2.667,2.682,2.549,2.549,0,0,1-2.22,2.523Zm-3.337-5.3a1.607,1.607,0,0,0,1.709-1.629,1.625,1.625,0,0,0-1.709-1.629H150.9v3.257Z"
                transform="translate(-71.771 -31.399)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_103"
                data-name="Trazado 103"
                d="M171.36,68.235a2.638,2.638,0,0,1-2.667,2.651h-2.411v4.263H165.26v-9.58h3.433a2.661,2.661,0,0,1,2.667,2.666m-1.022.016a1.666,1.666,0,0,0-1.741-1.693h-2.315v3.353H168.6a1.622,1.622,0,0,0,1.741-1.661"
                transform="translate(-79.139 -31.399)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_104"
                data-name="Trazado 104"
                d="M178.989,70.241a4.918,4.918,0,1,1,4.918,4.918,4.92,4.92,0,0,1-4.918-4.918m8.814,0a3.9,3.9,0,1,0-3.9,3.9,3.871,3.871,0,0,0,3.9-3.9"
                transform="translate(-85.714 -31.281)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_105"
                data-name="Trazado 105"
                d="M208.343,75.149h-1.166l-2.714-4.327h-1.8v4.327h-1.022v-9.58h3.433a2.664,2.664,0,0,1,2.667,2.682,2.549,2.549,0,0,1-2.219,2.523Zm-3.337-5.3a1.607,1.607,0,0,0,1.708-1.629,1.625,1.625,0,0,0-1.708-1.629h-2.348v3.257Z"
                transform="translate(-96.559 -31.399)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_106"
                data-name="Trazado 106"
                d="M220.949,72.913h-4.263l-.783,2.235h-1.118l3.465-9.58h1.134l3.464,9.58h-1.117Zm-.336-.974-1.788-5.158-1.8,5.158Z"
                transform="translate(-102.856 -31.399)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_107"
                data-name="Trazado 107"
                d="M236.371,66.59h-2.65v8.558H232.7V66.59h-2.651V65.568h6.323Z"
                transform="translate(-110.164 -31.399)"
                fill="#fff"
              ></path>
              <rect
                class="fill__gray"
                id="Rectángulo_118"
                data-name="Rectángulo 118"
                width="1.022"
                height="9.58"
                transform="translate(127.597 34.17)"
                fill="#fff"
              ></rect>
              <path
                class="fill__gray"
                id="Trazado_108"
                data-name="Trazado 108"
                d="M250.672,70.241a4.918,4.918,0,1,1,4.918,4.918,4.92,4.92,0,0,1-4.918-4.918m8.814,0a3.9,3.9,0,1,0-3.9,3.9,3.871,3.871,0,0,0,3.9-3.9"
                transform="translate(-120.041 -31.281)"
                fill="#fff"
              ></path>
              <path
                class="fill__gray"
                id="Trazado_109"
                data-name="Trazado 109"
                d="M281.208,65.568v9.58h-.958l-5.908-7.872v7.872H273.32v-9.58h.958L280.2,73.44V65.568Z"
                transform="translate(-130.886 -31.399)"
                fill="#fff"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </div>

    <!-- Hamburger icon solo visible en móviles -->
    <div class="hamburger" @click="toggleMenu">
      <div class="line" :class="{ 'line-1': isOpen }"></div>
      <div class="line" :class="{ 'line-2': isOpen }"></div>
      <div class="line" :class="{ 'line-3': isOpen }"></div>
    </div>

    <div v-if="language === 'EN'">
      <!-- Menú de navegación -->
      <ul class="nav-links" :class="{ 'nav-active': isOpen }">
        <li>
          <router-link to="/home" active-class="active" @click="closeMenu"
            >HOME</router-link
          >
        </li>
        <li>
          <router-link to="/about" active-class="active" @click="closeMenu"
            >ABOUT US</router-link
          >
        </li>
        <li>
          <router-link to="/history" active-class="active" @click="closeMenu"
            >HISTORY</router-link
          >
        </li>
        <li>
          <router-link to="/location" active-class="active" @click="closeMenu"
            >LOCATION</router-link
          >
        </li>
        <li>
          <router-link to="/operations" active-class="active" @click="closeMenu"
            >OPERATIONS</router-link
          >
        </li>
        <li>
          <router-link to="/esg" active-class="active" @click="closeMenu"
            >ESG</router-link
          >
        </li>
      </ul>
    </div>

    <div v-if="language === 'ES'">
      <!-- Menú de navegación -->
      <ul class="nav-links" :class="{ 'nav-active': isOpen }">
        <li>
          <router-link to="/home" active-class="active" @click="closeMenu"
            >INICIO</router-link
          >
        </li>
        <li>
          <router-link to="/about" active-class="active" @click="closeMenu"
            >QUIÉNES SOMOS</router-link
          >
        </li>
        <li>
          <router-link to="/history" active-class="active" @click="closeMenu"
            >HISTORIA</router-link
          >
        </li>
        <li>
          <router-link to="/location" active-class="active" @click="closeMenu"
            >UBICACIÓN</router-link
          >
        </li>
        <li>
          <router-link to="/operations" active-class="active" @click="closeMenu"
            >OPERACIONES</router-link
          >
        </li>
        <li>
          <router-link to="/esg" active-class="active" @click="closeMenu"
            >ASG</router-link
          >
        </li>
      </ul>
    </div>
    <!-- Botón para cambiar el idioma -->
    <div class="language-switcher">
      <button @click="changeLanguage">
        {{ language === 'EN' ? 'ES' : 'EN' }}
      </button>
    </div>

  </nav>
    </div>
</div>
  <div class="content" :class="{ 'content-blur': isOpen }"></div>
</template>

<script>
import { getLanguage, setLanguage } from "@/kernel/utils";
export default {
  name: "NavbarPublicEs",
  data() {
    return {
      isOpen: false,
      language: getLanguage(),
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
    changeLanguage() {
      this.language = this.language === "EN" ? "ES" : "EN";
      setLanguage(this.language);
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* Aseguramos que el body ocupe toda la altura */
a {
  color: #fff !important;
  text-decoration: none;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.external-space {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding-left: 128px;
  padding-right: 128px;
}
/* Navbar */
.navbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(10px);
  padding: 10px 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  transition: all 0.3s ease-in-out;
}

/* Logo dentro del navbar */
.logo {
  color: rgb(6, 0, 0);
  font-size: 24px;
  font-weight: bold;
}

/* Enlaces del navbar */
.nav-links {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
  transition: all 0.3s ease-in-out;
}

.nav-links li {
  margin-left: 20px;
}

.nav-links a {
  text-decoration: none;
  color: #fdfafa;
  font-size: 18px;
  transition: color 0.3s;
}

.nav-links a.active {
  color: #f15a29 !important;
}

.nav-links a:hover {
  color: #f15a29 !important;
}

/* Contenido de la página */
.content {
  overflow-y: auto; /* Permite el desplazamiento si el contenido es mayor que la altura visible */
  transition: filter 0.3s ease-in-out;
}

.content-blur {
  filter: blur(2px);
}

/* Hamburger menu - oculto por defecto */
.hamburger {
  display: none;
  cursor: pointer;
  z-index: 1100;
}

.hamburger .line {
  width: 25px;
  height: 3px;
  background-color: #fcf8f8;
  margin: 5px;
  transition: all 0.3s ease;
}

.hamburger .line-1 {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.hamburger .line-2 {
  opacity: 0;
}

.hamburger .line-3 {
  transform: rotate(45deg) translate(-5px, -6px);
}

/* Estilos responsivos */
@media (max-width: 968px) {
  .external-space {
    padding-left: 24px;
    padding-right: 24px;
  }
  .navbar {
    padding: 10px 16px;
  }

  .hamburger {
    display: block;
  }

  .nav-links {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(50, 50, 50, 0.95);
    backdrop-filter: blur(10px);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    clip-path: circle(0px at 90% -10%);
    -webkit-clip-path: circle(0px at 90% -10%);
    pointer-events: none;
    margin: 0;
  }

  .nav-links.nav-active {
    clip-path: circle(1500px at 90% -10%);
    -webkit-clip-path: circle(1500px at 90% -10%);
    pointer-events: all;
  }

  .nav-links li {
    margin: 15px 0;
    opacity: 0;
  }

  .nav-links.nav-active li {
    opacity: 1;
    transition: opacity 0.5s ease 0.2s;
  }

  .nav-links a {
    font-size: 20px;
  }
}
/* Estilos para el botón de cambio de idioma */
.language-switcher {
  display: flex;
  justify-content: center;
  align-items: center;
}

.language-switcher button {
  background-color: transparent;
  color: #fff;
  border: 1px solid #fff;
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.language-switcher button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
